var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGritLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 325,
    height: 39,
    viewBox: "0 0 325 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.2728 0L57.9092 0V3.54545L60.2728 3.54545V0Z",
    fill: "#fffbf4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0911 0V2.86887L322.107 2.86887V36.1311L2.89316 36.1311L2.89316 2.86887L50.8735 2.86887L50.8735 28.5741H54.0162L54.0162 0.483451H54.0098V0L0 0L0 39L325 39V0L64.0911 0Z",
    fill: "#fffbf4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1456 20.6239H23.9565V24.0427C22.6254 24.9609 21.0258 25.4462 19.3896 25.4286C15.5205 25.4286 12.9457 22.6634 12.9457 18.8917C12.9457 15.3421 15.6018 12.4136 19.0914 12.4136C20.065 12.388 21.0342 12.548 21.9434 12.8845C22.8527 13.2211 23.6842 13.7274 24.3902 14.3747L26.5043 11.9495C24.5081 10.2359 21.896 9.34431 19.2269 9.46543C17.9349 9.45037 16.6529 9.68564 15.4568 10.1573C14.2607 10.629 13.175 11.3274 12.2638 12.2113C11.3527 13.0952 10.6347 14.1465 10.1524 15.303C9.6701 16.4595 9.43333 17.6976 9.45609 18.9439C9.45609 24.2911 13.3522 28.3636 19.2812 28.3636C22.1835 28.3632 24.9884 27.3536 27.1819 25.5201L27.1819 17.8327L19.1456 17.8327V20.6239Z",
    fill: "#fffbf4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5593 16.2622C45.5593 12.7928 43.1698 10.6364 39.3525 10.6364L31.9092 10.6364L31.9092 28.3636H34.8602V22.186H38.5341L42.6322 28.3636L46.091 28.3636L41.5748 21.685C43.9106 20.9683 45.5593 19.1987 45.5593 16.2622ZM34.8483 19.4334V13.4778L39.1136 13.4778C41.2881 13.4778 42.5724 14.4926 42.5724 16.4397C42.5724 18.2664 41.2403 19.4334 39.1375 19.4334H34.8483Z",
    fill: "#fffbf4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0908 13.5222H64.631V28.3636H67.7325V13.5222H73.2726V10.6364L59.0908 10.6364V13.5222Z",
    fill: "#fffbf4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2655 10.6364L87.4546 10.6364V28.3636H94.2655C100.021 28.3636 104 24.4884 104 19.4841C104 14.4799 100.047 10.6364 94.2655 10.6364ZM94.2655 25.5285H90.6536V13.4778H94.2655C98.1134 13.4778 100.624 16.0148 100.624 19.5349C100.624 23.055 98.1396 25.5285 94.2655 25.5285Z",
    fill: "#fffbf4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.091 10.6364H107.545V28.3636H111.091V10.6364Z",
    fill: "#fffbf4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.3 20.624H129.145V24.0428C127.811 24.961 126.21 25.4463 124.571 25.4286C120.702 25.4286 118.134 22.6635 118.134 18.8918C118.134 15.3423 120.783 12.4138 124.273 12.4138C126.241 12.3661 128.148 13.071 129.579 14.3748L131.686 11.9497C129.69 10.2349 127.078 9.34315 124.409 9.46567C123.117 9.45061 121.835 9.68588 120.638 10.1575C119.442 10.6292 118.357 11.3276 117.445 12.2115C116.534 13.0954 115.816 14.1467 115.334 15.3032C114.852 16.4596 114.615 17.6977 114.638 18.9441C114.638 24.2912 118.534 28.3636 124.463 28.3636C127.365 28.3632 130.17 27.3536 132.364 25.5201V17.8328L124.3 17.8328V20.624Z",
    fill: "#fffbf4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.636 10.6364H137.091V28.3636H140.636V10.6364Z",
    fill: "#fffbf4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M166.377 10.6364L158.364 28.3636H161.611L163.481 24.1192H172.065L173.903 28.3636H177.273L169.286 10.6364H166.377ZM164.695 21.3735L167.805 14.3329L170.942 21.3735H164.695Z",
    fill: "#fffbf4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M184.075 10.6364H180.818V28.3636L193.818 28.3636V25.5285H184.075V10.6364Z",
    fill: "#fffbf4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M158.363 13.5222V10.6364L144.182 10.6364V13.5222H149.722V28.3636H152.823V13.5222H158.363Z",
    fill: "#fffbf4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M218.918 18.0063H210.076V10.6364H206.818V28.3636H210.076V20.8922H218.918V28.3636H222.182V10.6364H218.918V18.0063Z",
    fill: "#fffbf4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M229.96 20.816H238.666V18.0317H229.96V13.4207L239.785 13.4207V10.6364L226.909 10.6364V28.3636L239.909 28.3636V25.5793H229.96V20.816Z",
    fill: "#fffbf4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M251.442 10.6426L243.455 28.3636H246.701L248.565 24.1129H257.175L258.994 28.3636H262.364L254.383 10.6364L251.442 10.6426ZM249.76 21.3798L252.87 14.3392L256.007 21.3798H249.76Z",
    fill: "#fffbf4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M270.05 10.6364H267.091V28.3636L278.909 28.3636V25.5285H270.05V10.6364Z",
    fill: "#fffbf4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M309.925 10.6364V18.0063H301.076V10.6364H297.818V28.3636H301.076V20.8922H309.925V28.3636H313.182V10.6364H309.925Z",
    fill: "#fffbf4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M278.909 13.5222H284.918V28.3636H288.271V13.5222L294.273 13.5222V10.6364L278.909 10.6364V13.5222Z",
    fill: "#fffbf4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGritLogoWhite);
export default __webpack_public_path__ + "static/media/grit-logo-white.a5ff2fe87aed6da5ced2cdaf18c81a97.svg";
export { ForwardRef as ReactComponent };